import { globalStores } from '@/editor/stores';
import { ENTITY_PRIORITY, ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { EContainerType } from '@/editor/types/entity';
import { EEntityType, IWallEdge } from '@/editor/types';
import { IMaterialInfo } from '@/editor/data/material/material';
import RegionModel from './regionModel';

interface IParams {
  id: string;
  materialInfo: IMaterialInfo;
  corePathInfos: IWallEdge[];
  coreHoleInfos: IWallEdge[][];
}

class RoomModel extends RegionModel {
  constructor(roomData: IParams) {
    super(roomData);

    this._modelGroup.userData.containerType = EContainerType.entity;
    this._modelGroup.userData.entityId = roomData.id;
    this._modelGroup.userData.type = EEntityType.Room;
    this._modelGroup.userData.priority = ENTITY_PRIORITY.room;

    this.updateModel(roomData);
    this.setDisplayOrder(ENTITY_RENDER_ORDER.floor);
    globalStores.editorStateStore.sceneInfo.scene2d.intersectableGroup.add(this._modelGroup);
  }
}

export default RoomModel;
